import jwtDecode from "jwt-decode";
import IO from "socket.io-client";
import { getChatsAtendimento, getChatsFinalizados, getChatsGeral, getChatsPendente, getCountsChats, removeMsgEnviar, reorderChatsAtendimento, removeMensagensEnviarByChatId, setChatsAnalysis, setMensagensEnviar, setPushMensagemMeta, updateChatInfoField, updateChatList, updateMensagensEnviar, updateChatGrupoFromSocket, getChatsGrupos, patchMessageById } from "src/redux/slices/chat";

// import Actions from "../constants/Actions";
import { setMetaMessages, setMessageWhatsapp, getMessagesMeta, addNewMessageCliente } from './redux/slices/chat'
import { mapMetaMessageToBubble, enrichQuotedMetaMessages } from './utils/mapMetaMessage'
import { setDefcon1, setUpdateAvailable, setLoadingQrcodeWhatsapp, setQrcode, setStateWhatsapp, setStatusQrcode } from 'src/redux/slices/global'
import { getIoInit, setAddRoomUnread, setOnlineUsers, setMessage, getListaStaffsWithoutIsGroup, setIsOnlineUsers } from 'src/redux/slices/staff';
import { store } from "./redux/store";
// import getRooms from "./getRooms";
import { notifyMe, notifyMeComentario, notifyMeStaff, notifyNewMessage, obterNumeroPorClienteId, soNumeros } from 'src/utils/functions';
import { getListaNotificacoes } from "src/redux/slices/notificacoes";
import { getRefreshComments, getListaColunas, getListaTickets } from "src/redux/slices/chamados";
import getActionClienteByClienteId from "src/actions/clientes/getActionClienteByClienteId";
import actionListaClientesCanais from "src/actions/clientes/actionListaClientesCanais";
import { promise as socketPromise } from './lib/socket.io-promise';
import Worker from "./actions/idb/workers/app.worker.worker?worker";
import { downloadMediaAndSaveCache } from "./helpers/cache.helper";
import { checkMsgToInsert } from "./utils/chats.utils";
import { getSessionStorageItem, setSessionStorageItem } from "./services/sessionStorage";
import { pushAlerta, removerChatDoBoard, marcarNaoLidoNoBoard, getDivisoes } from "src/redux/slices/chat-arquivo";
import { receiveSocketComment, patchComment, getSocialPosts } from "src/redux/slices/socialComments";
import {
  getPermissionState,
  isEventoRelevante,
  notify,
  playAlert,
  rotuloMensagem,
  safeHandler,
  shouldNotifyMessage,
} from "src/services/notifications";
import { PATH_CHAT } from "src/routes/paths";
import Config from "./config";

// O `cliente_data` do localStorage so e reescrito no login (JWTContext). Uma
// sessao antiga carrega um snapshot velho, entao ler uma unica vez no boot do
// socket faz o painel operar com config desatualizada pelo resto da sessao.
// Ler sob demanda (e com try/catch, porque ja apareceu JSON corrompido ali)
// deixa o handler enxergar o valor atual.
const lerClienteData = () => {
  try {
    return JSON.parse(localStorage.getItem('cliente_data')) || null;
  } catch {
    return null;
  }
};

const mesmoId = (a, b) => a != null && b != null && String(a) === String(b);
const incluiId = (lista, valor) => Array.isArray(lista) && lista.some((item) => mesmoId(item, valor));

// staff.room fica setado ao abrir o minichat e NAO e limpo ao fechar a janelinha.
// Usar so isso como "esta olhando" silenciava a proxima mensagem. A evidência
// real e a pagina /chats/interno/:id ou o minichat ainda presente no sessionStorage.
const chatInternoEstaSendoVisto = (roomId) => {
  if (!roomId || typeof window === 'undefined') return false;
  const pathname = window.location.pathname || '';
  if (pathname.startsWith('/chats/interno/')) {
    const idNaUrl = pathname.slice('/chats/interno/'.length).split('/')[0];
    if (mesmoId(idNaUrl, roomId)) return true;
  }
  const mini = getSessionStorageItem('chatInternoMiniId');
  return Boolean(mini?._id && mesmoId(mini._id, roomId));
};

const handleMensagemChatInterno = (dispatch, data, evento) => {
  try {
    const payload = data?.data?.scope?.data ?? data?.data?.scope ?? data;
    const room = payload?.room;
    const message = payload?.message;
    const currentRoom = store.getState().staff.room;

    console.debug(`[chat-interno] evento ${evento}`, { roomId: room?._id, currentRoomId: currentRoom?._id });

    if (!room?._id) {
      console.warn(`[chat-interno] payload sem room._id em ${evento}`, data);
      return;
    }

    const vendoEstaSala = chatInternoEstaSendoVisto(room._id);
    const deveNotificar = shouldNotifyMessage({
      chatIdEvento: room._id,
      chatAbertoId: vendoEstaSala ? room._id : null,
    });

    if (deveNotificar) {
      playAlert('message');
      notifyMeStaff('Atenção', 'Você tem uma nova mensagem no Chat Interno');
      dispatch(setAddRoomUnread(room._id));
    }

    if (currentRoom?._id === room._id) dispatch(setMessage(message));

    const activeMiniChat = getSessionStorageItem('chatInternoMiniId');
    if (activeMiniChat && activeMiniChat._id === room._id) {
      const newMessages = [...(activeMiniChat.messages || []), message];
      setSessionStorageItem('chatInternoMiniId', { ...activeMiniChat, messages: newMessages });
    }

    dispatch(getListaStaffsWithoutIsGroup());
  } catch (err) {
    console.error(`[chat-interno] handler ${evento} falhou`, err, data);
  }
};

// Função utilitária para acessar o estado de forma segura
// Optimistic update da janela de atendimento: quando a inbound traz `referral`, a
// conversa começou num anúncio (Click-to-WhatsApp) e a Meta concede 72h em vez de 24h.
// Sem carimbar aqui, o painel só enxergaria a janela estendida no próximo refetch.
// `ctwaWindowClosedAt: null` porque um clique novo reabre a janela que um 131047
// anterior tinha fechado — o lais-webhook faz o mesmo no banco.
const ctwaScopeFromMessage = (message) =>
  !message?.fromMe && message?.referral
    ? { ctwaReferralAt: new Date(), ctwaWindowClosedAt: null }
    : {};

const getSafeState = (statePath) => {
  try {
    const state = store.getState();
    const path = statePath.split('.');
    let result = state;

    for (const key of path) {
      if (result && typeof result === 'object' && key in result) {
        result = result[key];
      } else {
        return null;
      }
    }

    return result;
  } catch (error) {
    console.error('Erro ao acessar estado:', error);
    return null;
  }
};

// O backend remove aspas simples e asteriscos do texto antes de mandar pra Meta
// (whatsapp.controller: message.replace(/['’*]/g, "")), entao o echo volta
// diferente do body otimista. Normaliza os dois lados antes de comparar, senao o
// balao de preview nunca e removido e a mensagem aparece duplicada.
const normalizarBodyMeta = (texto) => (texto || '')
  .replace(/['’*]/g, '')
  .replace(/\s+/g, ' ')
  .trim();

// Remove de mensagensEnviar o balao otimista correspondente ao echo recebido.
// Sempre limita ao chat_id do echo: remover só por body apagava o preview de
// outra conversa que tivesse o mesmo texto pendente.
const reconciliarMensagemOtimista = (dispatch, mapped, chatId) => {
  if (!mapped?.fromMe) return;
  const enviar = store.getState().chat.mensagensEnviar;
  const listaEnviar = Array.isArray(enviar) ? enviar : [];
  if (listaEnviar.length === 0) return;
  const alvo = normalizarBodyMeta(mapped.body);
  const chatIdStr = chatId != null ? String(chatId) : null;
  const filtradas = listaEnviar.filter((m) => {
    if (chatIdStr && m?.chat_id && String(m.chat_id) !== chatIdStr) return true;
    return normalizarBodyMeta(m.body) !== alvo;
  });
  if (filtradas.length !== listaEnviar.length) dispatch(updateMensagensEnviar(filtradas));
};

const initIO = token => (dispatch) => {
  const user = jwtDecode(token);

  // `JSON.parse` cru aqui derrubava o initIO inteiro quando o `cliente_data`
  // estava ausente ou corrompido — nenhum listener era registrado e o painel
  // ficava totalmente mudo, sem erro visivel.
  const clienteParse = lerClienteData();
  const wbWorker = new Worker();

  // O ws de producao recusa o handshake vindo de http://localhost:3000 (503 no
  // /socket.io/), entao em dev da para apontar para um servidor local via
  // VITE_WS_URL sem mexer no codigo.
  const urlWs = import.meta.env.VITE_WS_URL || (Config.dev ? Config.url_dev_ws : Config.urlWs);
  let io = IO(urlWs + '/');
  io.request = socketPromise(io);

  // Registra o handler ja envolvido pelo safeHandler. Usar `on(...)` no lugar
  // do listener cru garante que nenhum handler novo escape do try/catch.
  // Os eventos de ciclo de vida do socket (connect/disconnect/...) seguem no
  // listener cru porque controlam auth e redirect — nao devem ser engolidos.
  const on = (evento, handler) => io.on(evento, safeHandler(evento, handler));

  // Refetch de lista com debounce trailing por lista.
  //
  // Os handlers antigos disparavam um setTimeout por item dentro de um for, e o
  // refetch de `newMessage` rodava a cada mensagem. Como o emit e endereçado a
  // organizacao inteira, num cliente de volume alto isso vira uma requisicao por
  // agente por mensagem. Agrupando por lista, uma rajada vira um request so.
  // Limites iguais aos dos loops originais que este helper substituiu.
  const REFETCH_DEBOUNCE_MS = 3000;
  const timersRefetch = {};
  const refetchPorLista = {
    Atendendo: () => getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false),
    Geral: () => getChatsGeral(user.clienteId, user.id, user.setorId, 100, false),
    Pendente: () => getChatsPendente(user.clienteId, user.id, user.setorId, 10, false),
    Finalizado: () => getChatsFinalizados(user.clienteId, user.id, user.setorId, 10, false),
  };

  // So `count_pendente`. A query de Pendente filtra por direciona_usuarios /
  // direciona_setores (chats.controller.js:147), entao o contador so sobe quando
  // o cliente entrou na fila DESTE usuario. `count_geral` vem de um find sem
  // filtro nenhum (:167) e faria o alerta disparar para a organizacao inteira.
  const contarFila = () => store.getState().chat?.countsListaChats?.count_pendente || 0;

  const agendarRefetchListas = (listas, { alertarFila = false, ignorar = [] } = {}) => {
    if (!Array.isArray(listas)) return;
    listas.forEach((item) => {
      if (ignorar.includes(item)) return;
      const acao = refetchPorLista[item];
      if (!acao) return;
      clearTimeout(timersRefetch[item]);
      timersRefetch[item] = setTimeout(() => {
        delete timersRefetch[item];
        // So o refetch de Pendente move `count_pendente`; medir na volta de
        // Geral compararia o contador contra ele mesmo.
        const antes = alertarFila && item === 'Pendente' ? contarFila() : null;

        Promise.resolve(dispatch(acao())).then(() => {
          // Comparar os contadores evita alertar num refetch que nao trouxe
          // ninguem novo — o evento dispara para a org inteira.
          if (antes == null || contarFila() <= antes) return;
          playAlert('queue');
          notify({
            title: 'CLIENTE EM ESPERA',
            body: 'Há novos clientes aguardando atendimento',
            tag: 'fila',
            url: PATH_CHAT.chat.root,
          });
        });
      }, REFETCH_DEBOUNCE_MS);
    });
  };

  // Ponto unico de alerta de mensagem nova.
  //
  // A decisao estava espalhada em tres ramos do handler newMessage, todos
  // aninhados em `if (isMyChat || root)` e re-checando `scope.usuario_id ===
  // user.id`. Consolidar num lugar so foi o que permitiu corrigir a supressao
  // por foco sem repetir a regra tres vezes.
  //
  // O publico continua sendo exatamente o mesmo de antes (`isEventoRelevante`
  // exige ser o dono da conversa). O que mudou e QUANDO suprimir: a aba fora de
  // primeiro plano passa a alertar mesmo com a conversa aberta.
  const alertarNovaMensagem = ({ data, chatInfo, dataChatByLista, chatIdEvento }) => {
    const scope = data?.data?.scope;
    const message = scope?.message;
    if (!message || message.fromMe) return;

    // Em multisession o painel opera varios numeros: sem este filtro o agente
    // recebia alerta de mensagem enviada para um numero que nao e dele.
    // Webchat/telegram nao tem `to` = telefone (bot id / session key), entao esse
    // filtro nunca bateria pra eles e silenciava o alerta em toda org multisession.
    if (clienteParse?.multiSession === 1 && !['webchat', 'telegram'].includes(message.platform)) {
      const numerosDoUsuario = clienteParse?.numeros_subs || [];
      if (!numerosDoUsuario.includes(soNumeros(message.to))) return;
    }

    if (!isEventoRelevante({ envelope: data.data, scope, user })) return;
    if (!shouldNotifyMessage({ chatIdEvento, chatAbertoId: chatInfo?.numeroCliente })) return;

    playAlert('message');
    notifyNewMessage(message, dataChatByLista, scope.chat_id);
  };

  ////// sistema antigo

  // Mantido como shim para os call sites existentes. O respeito ao mute e o
  // cooldown agora vivem dentro do playAlert, que e o mesmo caminho usado por
  // todos os alertas — antes so esta funcao checava o `soundNotification` e os
  // outros ~10 blocos de audio ignoravam o botao de mudo.
  function playSoundNotification() {
    playAlert('queue');
  }

  io.on('connect', () => {
    const currentToken = localStorage.getItem('token');
    if (currentToken) {
      io.emit('authenticate', { token: currentToken });
    } else {
      io.disconnect();
    }
  });

  // Tudo que chegou com o socket fora do ar nunca foi renderizado e o painel nao
  // tinha nenhum catch-up: o agente so via as mensagens perdidas se recarregasse
  // a pagina na mao. socket.io-client v2 reemite 'connect' (e portanto
  // 'authenticated') a cada reconexao, entao esse e o gancho certo.
  const recarregarTudo = () => {
    dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
    dispatch(getChatsPendente(user.clienteId, user.id, user.setorId, 100, false));
    dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, false));
    dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
    dispatch(getListaNotificacoes(user.id));
  };

  let primeiraAutenticacao = true;

  on('authenticated', () => {
    dispatch(getIoInit(io));
    if (primeiraAutenticacao) {
      primeiraAutenticacao = false;
      return;
    }
    recarregarTudo();
  });

  // Aba em background e notebook dormindo nao derrubam o socket, mas travam os
  // timers e enfileiram eventos que chegam todos de uma vez (ou se perdem).
  // Voltar de uma ausencia longa tambem merece catch-up.
  let escondidoDesde = null;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      escondidoDesde = Date.now();
      return;
    }
    if (escondidoDesde && Date.now() - escondidoDesde > 60000) recarregarTudo();
    escondidoDesde = null;
  });

  io.on('unauthorized', (error) => {
    console.warn('WebSocket auth failed:', error?.message);
    localStorage.removeItem('token');
    window.location.href = '/login';
  });

  io.on('connect_error', (error) => {
    console.warn('WebSocket connection error:', urlWs, error?.message);
  });

  // verificar se há chats pendentes, havendo, toca-se um sinal sonoro
  // setInterval(async () => {
  //   getActionListaChatsByStatus({ clienteId: user.clienteId, status: "Pendente", usuarioId: user.id, setorId: user.setorId }).then(res => {
  //     if (res.data.length > 0) {
  //       playSoundNotification();
  //       notifyMe2(res.data.length);
  //     }

  //   }).catch(err => console.log(err));

  // }, 180000);


  setInterval(async () => {
    const roomsWithNewMessages = store.getState().staff.roomsWithNewMessages;
    if (roomsWithNewMessages) {
      if (roomsWithNewMessages.length > 0) {
        notifyMeStaff('Atenção', 'Você tem mensagens não vistas no Chat Interno');
      }
    }
  }, 90000);

  on('novo_comentario', (data) => {
    if (!data) return null;
    const { nomeAutor, setorAutor, backoffice, filial, texto } = data.comentario

    let combineUsuarios = data.result;
    if (combineUsuarios.includes(user.id)) {

      dispatch(getListaNotificacoes(user.id))
      if (user.id !== data.comentario.autor_id) {
        playAlert("ticket");
        notifyMeComentario(`${nomeAutor}`, `\nDiz:  ${texto} \n\n Chamado: #${data.chamado.chamado}`);;
      }
      dispatch(getRefreshComments(data.chamado._id))
    }
  });

  on('job-count-chamados-pendentes', (data) => {

    if (!data) return null;


    if (data.direcionado_setor.includes(user.setorId) || data.direcionado_para.includes(user.id) || data.direcionado_usuarios.includes(user.id)) {
      playAlert("ticket");

      notifyMeStaff('Atenção', 'Você tem chamados pendentes');
      dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id }));
      dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id }));
      dispatch(getListaNotificacoes(user.id))
    }

  });

  // Abertura de chamado nunca avisava: este handler so fazia refetch, sem som e
  // sem notificacao. Notificar direto no evento viraria spam, porque ele dispara
  // para qualquer mexida em chamado da organizacao. Em vez disso comparamos as
  // notificacoes nao lidas antes e depois do refetch e avisamos so o delta — o
  // backend ja grava a Notificacao com titulo e numero do chamado na criacao.
  on('atualizar_chamados', async (data) => {
    if (!data) return;

    const meuEvento = mesmoId(data.cliente_id, user.clienteId) || mesmoId(data.usuario_id, user.id);
    if (!meuEvento) return;

    const idsAntes = new Set(
      (store.getState().notificacoes?.notificacoesNaoLidas || []).map((n) => String(n._id))
    );

    dispatch(getListaColunas({ setorId: user.setorId, usuarioId: user.id }));
    dispatch(getListaTickets({ setorId: user.setorId, usuarioId: user.id }));
    await dispatch(getListaNotificacoes(user.id));

    const novas = (store.getState().notificacoes?.notificacoesNaoLidas || []).filter(
      (n) => !idsAntes.has(String(n._id))
    );
    if (novas.length === 0) return;

    playAlert('ticket');
    const primeira = novas[0];
    notify({
      title: novas.length > 1 ? `${novas.length} novas notificações` : (primeira.titulo || 'Novo chamado'),
      body: novas.length > 1 ? 'Você tem novos chamados no painel' : (primeira.mensagem || ''),
      tag: 'chamados',
      url: '/dashboard/chamados',
    });
  });

  // Tarefas: o backend grava a Notificacao ANTES de emitir, entao o refetch do
  // sino ja a encontra. O scope traz titulo/mensagem quando o evento merece
  // alerta (atribuicao, comentario, prazo, conclusao, lembrete); sem titulo e so
  // "recarrega o board" (prioridade, checklist, estagio intermediario).
  on('atualizar_tarefas', (data) => {
    const envelope = data?.data || {};
    const paraMim = envelope.whoTo === 'usuarioId' && mesmoId(envelope.to, user.id);
    if (!paraMim) return;
    const scope = envelope.scope || {};

    dispatch(getListaNotificacoes(user.id));
    window.dispatchEvent(new CustomEvent('lais:tarefas-atualizadas', { detail: scope }));

    if (!scope.titulo) return;
    playAlert('ticket');
    const permissao = getPermissionState();
    if (permissao !== 'granted') {
      // notify() sai em silencio sem permissao — sem este log o usuario ficava
      // sem aviso nenhum e sem pista do porque. O banner de permissao reaparece.
      console.debug(`[tarefas] alerta "${scope.titulo}" suprimido: permissao do navegador = ${permissao}`);
    }
    notify({
      title: scope.titulo,
      body: scope.mensagem || '',
      tag: `tarefa-${scope.tarefa_id || 'geral'}`,
      url: scope.tarefa_id ? `/dashboard/tarefas?tarefa=${scope.tarefa_id}` : '/dashboard/tarefas',
    });
  });

  on('qrcodeEvent', data => {

    const { qrcode, event } = data.data.scope;

    if (event === "qrcode") {
      dispatch(setQrcode(`data:image/png;base64,${qrcode}`))
      dispatch(setLoadingQrcodeWhatsapp(false))
      dispatch(setStatusQrcode('notLogged'))
    }

  });

  on('statusFindEvent', data => {
    const { event, status } = data.data.scope

    dispatch(setStatusQrcode(status))
    if (status === 'inChat') {
      window.location.href = "/chats/chat"
    }

  });

  on('message-in', data => handleMensagemChatInterno(dispatch, data, 'message-in'));

  on('new-message-internal-chat', data => handleMensagemChatInterno(dispatch, data, 'new-message-internal-chat'));

  on('job-count-chats-pendentes', data => {
    const cliente = lerClienteData();
    const clientesId = data?.data?.clientes_id || [];
    const setoresId = data?.data?.direcionado_setor || [];
    const usuariosId = data?.data?.direcionado_usuarios || [];
    const isMultisession = cliente?.multiSession === 1;

    // Os ids vem do Mongo como ObjectId serializado; comparar com === contra a
    // string do JWT falhava silenciosamente em parte dos payloads.
    const souDaOrg = isMultisession
      ? clientesId.some((id) => incluiId(cliente?.cliente_ids, id))
      : incluiId(clientesId, user.clienteId);

    if (!souDaOrg) return;

    const souAlvo = incluiId(setoresId, user.setorId) || incluiId(usuariosId, user.id);
    if (!souAlvo) return;

    dispatch(getChatsPendente(user.clienteId, user.id, user.setorId));
    if (data?.sound) {
      notifyMe2();
      playSoundNotification();
    }
  });


  // Fora do gate `ready_v2_webhook` de proposito: este e o unico alerta de
  // "cliente novo em espera". Quando o `cliente_data` do localStorage esta velho
  // ou sem o campo, o gate derrubava o registro de TODOS os listeners de
  // whatsapp e a fila ficava muda — enquanto o chat interno (registrado acima do
  // gate) continuava avisando normalmente. Era exatamente a assimetria relatada.
  // Handler de alerta puro: nao muta estado, entao sair do gate nao duplica nada.
  on('newChatToUser', data => {
    if (data?.data?.whoTo !== "usuarioId") return;
    if (!incluiId(data?.data?.scope?.userIds, user.id)) return;

    createNotify('NOVO CHAT', 'Você tem um novo chat no seu painel');
    playSoundNotification();
  });


  // Arquivo de conversas: mantém o board em sincronia sem refetch total.
  // Fora do gate `ready_v2_webhook` de propósito — o arquivo não depende dele.
  on('chat-arquivo-atualizado', data => {
    const scope = data?.data?.scope;
    if (!scope) return;
    // mesmoId: evita descartar o evento quando to/clienteId diferem só por tipo
    // (string vs ObjectId serializado) — comum em multisession.
    if (data.data.whoTo === "clienteId" && !mesmoId(data.data.to, user.clienteId)) return;

    if (scope.tipo === 'desarquivado') {
      dispatch(removerChatDoBoard(scope.chat_id));

      // Telegram/webchat/ML anexam a mensagem na janela aberta sem olhar
      // statusRoom. Sem este patch, o header continua em "Arquivado" (botão
      // desarquivar, badge, etc.) mesmo com a conversa já fora do arquivo no DB.
      const chatAberto = store.getState().chat.chatInfo;
      if (chatAberto && mesmoId(chatAberto._id, scope.chat_id)) {
        const destino = scope.status_destino || 'Geral';
        dispatch(updateChatInfoField('statusRoom', destino));
        dispatch(updateChatInfoField('arquivo_divisao_id', null));
        dispatch(updateChatInfoField('arquivado_em', null));
        dispatch(updateChatInfoField('desarquivado_em', scope.desarquivado_em || new Date().toISOString()));
      }

      // Tag "Desarquivado" na listagem (se o chat já estiver na lista local;
      // o refetch via socket-device-refresh traz o campo do banco).
      // Não altera statusRoom aqui: o chat ainda não está na lista de destino;
      // o refetch é quem o insere com o documento completo.
      const momentoDesarquive = scope.desarquivado_em || new Date().toISOString();
      dispatch(updateChatList({
        _id: scope.chat_id,
        scope: { desarquivado_em: momentoDesarquive },
      }));

      // O alerta só faz sentido quando a conversa saiu sozinha do arquivo.
      if (scope.origem === 'mensagem_cliente') {
        dispatch(pushAlerta(scope));
        createNotify(
          'CONVERSA DESARQUIVADA',
          `${scope.nome_cliente || 'Uma conversa'} voltou para ${scope.status_destino || 'Atendimentos'}`
        );
      }
    } else if (scope.tipo === 'nova_mensagem_arquivada') {
      dispatch(marcarNaoLidoNoBoard(scope.chat_id));
    } else if (scope.tipo === 'arquivado') {
      dispatch(getDivisoes());
    }
  });

  // Fora do gate `ready_v2_webhook`: e o evento que traz a fila (Geral/Pendente)
  // para o painel. Handler de refetch + alerta, nao muta mensagem — sair do gate
  // nao pode duplicar nada.
  on('socket-device-refresh-list-chats', data => {
    const paraMinhaOrg = data?.data?.whoTo === "clienteId" && mesmoId(data?.data?.to, user.clienteId);
    const paraMim = data?.data?.whoTo === "usuarioId" && mesmoId(data?.data?.to, user.id);
    if (!paraMinhaOrg && !paraMim) return;

    agendarRefetchListas(data?.data?.scope?.lista_atualizar, { alertarFila: true });
  });

  // O gate era um `if` unico envolvendo o REGISTRO de todos os listeners de
  // mensagem, avaliado uma vez no boot com o snapshot do localStorage. Com o
  // `cliente_data` velho (ele so e reescrito no login), nenhum listener era
  // registrado e o painel ficava mudo para conversas a sessao inteira, enquanto
  // o chat interno — registrado acima do gate — seguia avisando.
  //
  // Agora o gate e por evento e le o valor atual, mas a CONDICAO continua a
  // mesma de antes (truthy). Quem ficou fail-open foram apenas os handlers de
  // alerta puro — newChatToUser e socket-device-refresh-list-chats — que saíram
  // do gate por completo. Aqui ficam so os que mutam estado de mensagem, onde
  // rodar num cliente v1 poderia de fato duplicar conteudo na tela.
  const isReadyV2 = () => Boolean(lerClienteData()?.config?.ready_v2_webhook);

    // recenbendo mensagens websocket front vindo do webhook
    on('newMessage', async data => {
      if (!isReadyV2()) return;

      // [NOVO] Mensagens em grupo: atualiza chatsGrupos e sai cedo (não passa pelo flow 1:1)
      if (data?.data?.scope?.isGroup === true) {
        try {
          dispatch(updateChatGrupoFromSocket(data.data.scope));
        } catch (err) {
          console.log('Erro updateChatGrupoFromSocket', err?.message);
        }
        return;
      }

      const chatIdClean = data.data.scope.message.chatId.replace('@lid', '').replace('@c.us', '');
      data.data.scope.message.chatId = chatIdClean;

      if (!data || !data?.data?.scope?.message) return;
      if (data.data.scope.message.chatId === "status@broadcast") return;

      // if (clienteParse.numero + '@c.us' !== data.data.scope.message.to || clienteParse.numero + '@c.us' !== data.data.scope.message.chatId) {
      //   console.log('nao é meu numero DO CLIENTE no painel', data.data.scope?.message)
      //   return;
      // }

      const newMessage = data?.data?.scope?.message;
      const storeMsgsEnviar = getSafeState('chat.mensagensEnviar');

      // Garantir que storeMsgsEnviar seja um array válido
      const mensagensEnviar = Array.isArray(storeMsgsEnviar) ? storeMsgsEnviar : [];


      if (mensagensEnviar.length > 0 && newMessage.type === "chat") {
        const chatIdEcho = data?.data?.scope?.chat_id;
        const mensagensFiltradas = mensagensEnviar.filter((msg) => {
          if (chatIdEcho && msg?.chat_id && String(msg.chat_id) !== String(chatIdEcho)) return true;
          return msg.body !== newMessage.body;
        });
        if (mensagensFiltradas.length !== mensagensEnviar.length) {
          dispatch(updateMensagensEnviar(mensagensFiltradas));
        }
      }

      const chatInfo = store.getState().chat.chatInfo;
      const listaChatsAtendendo = store.getState().chat.chatsAtendimento;
      // soNumeros descarta o prefixo "TG." do Telegram (e a chave do webchat),
      // entao o find por digitos nunca casava nesses canais: toda mensagem
      // disparava refetch da lista e a notificacao saia sem o nome do contato.
      // O chatIdClean e igual ao numeroCliente em todos os canais.
      const dataChatByLista = listaChatsAtendendo.find(item =>
        item.numeroCliente === chatIdClean ||
        item.numeroCliente === soNumeros(data.data.scope.message.chatId)
      );

      // Alerta antes de qualquer ramo de atualizacao de estado: notificar nao
      // pode depender do chat existir na lista local nem de ter dono definido.
      alertarNovaMensagem({ data, chatInfo, dataChatByLista, chatIdEvento: chatIdClean });

      // === WEBCHAT: fluxo dedicado ===
      // O matching padrão abaixo assume from/to = telefone (multisession, numeros_subs)
      // e usuario_id; o webchat não tem isso. Tratamos aqui de forma direta: append
      // na janela aberta (por numeroCliente) + atualização da lista. Só afeta webchat.
      if (newMessage?.platform === 'webchat') {
        if (chatInfo && chatIdClean === chatInfo.numeroCliente) {
          dispatch(setMessageWhatsapp(newMessage));
          dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));
          if (!newMessage.fromMe) {
            dispatch(addNewMessageCliente({ ...newMessage, chatId: data.data.scope.chat_id }));
          }
        }
        dispatch(updateChatList({
          _id: data.data.scope.chat_id,
          scope: {
            ...(!newMessage.fromMe ? { novaMensagem: 'sim', lastDateMsgClient: new Date() } : {}),
            dataUltimaMensagem: new Date(),
            lastUpdate: new Date(),
            lastMessageWpp: {
              type: newMessage.type,
              message: checkMsgToInsert(newMessage),
              fromMe: newMessage.fromMe,
              timestamp: newMessage.t,
              ack: newMessage.ack,
              id: newMessage.id,
            },
          },
        }));
        if (!dataChatByLista) {
          dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
        }
        setTimeout(() => dispatch(reorderChatsAtendimento()), 200);
        return;
      }

      // === TELEGRAM: fluxo dedicado ===
      // O matching padrão abaixo (isMyChat/multiSession) assume from/to = telefone
      // (numeros_subs). No Telegram `to` é o id numérico do bot — nunca bate contra
      // numeros_subs nem contra numeros_subs_data — então a mensagem nunca entrava
      // em setMessageWhatsapp/updateChatList e só aparecia depois de um reload
      // (que busca o histórico pelo REST, sem passar por esse matching). Espelha o
      // tratamento do webchat, que tem o mesmo problema de não ter telefone.
      if (newMessage?.platform === 'telegram') {
        if (chatInfo && chatIdClean === chatInfo.numeroCliente) {
          dispatch(setMessageWhatsapp(newMessage));
          dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));
          if (!newMessage.fromMe) {
            dispatch(addNewMessageCliente({ ...newMessage, chatId: data.data.scope.chat_id }));
          }
        }
        dispatch(updateChatList({
          _id: data.data.scope.chat_id,
          scope: {
            ...(!newMessage.fromMe ? { novaMensagem: 'sim', lastDateMsgClient: new Date() } : {}),
            dataUltimaMensagem: new Date(),
            lastUpdate: new Date(),
            lastMessageWpp: {
              type: newMessage.type,
              message: checkMsgToInsert(newMessage),
              fromMe: newMessage.fromMe,
              timestamp: newMessage.t,
              ack: newMessage.ack,
              id: newMessage.id,
            },
          },
        }));
        if (!dataChatByLista) {
          dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
        }
        setTimeout(() => dispatch(reorderChatsAtendimento()), 200);
        return;
      }

      // === MERCADO LIVRE: fluxo dedicado ===
      // Mesmo problema do webchat e do Telegram: o matching padrão abaixo trata
      // from/to como telefone (numeros_subs), e no Mercado Livre a chave da
      // conversa é "ML.<buyer_user_id>". Sem este desvio a mensagem não entra em
      // setMessageWhatsapp/updateChatList e só aparece depois de um reload.
      // Bloco idêntico ao do Telegram acima — os três são a mesma solução para
      // "canal sem telefone"; consolidar os três é mudança à parte, porque
      // mexeria no caminho de webchat e Telegram, que hoje funcionam.
      if (newMessage?.platform === 'mercado_livre') {
        if (chatInfo && chatIdClean === chatInfo.numeroCliente) {
          dispatch(setMessageWhatsapp(newMessage));
          dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));
          if (!newMessage.fromMe) {
            dispatch(addNewMessageCliente({ ...newMessage, chatId: data.data.scope.chat_id }));
          }
        }
        dispatch(updateChatList({
          _id: data.data.scope.chat_id,
          scope: {
            ...(!newMessage.fromMe ? { novaMensagem: 'sim', lastDateMsgClient: new Date() } : {}),
            dataUltimaMensagem: new Date(),
            lastUpdate: new Date(),
            lastMessageWpp: {
              type: newMessage.type,
              message: checkMsgToInsert(newMessage),
              fromMe: newMessage.fromMe,
              timestamp: newMessage.t,
              ack: newMessage.ack,
              id: newMessage.id,
            },
          },
        }));
        if (!dataChatByLista) {
          dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
        }
        setTimeout(() => dispatch(reorderChatsAtendimento()), 200);
        return;
      }

      const isMyChat = data.data.scope.usuario_id === user.id;
      const isMultisession = clienteParse?.multiSession === 1;

      console.log('isMyChat', isMyChat)

      // if (!isMyChat) {
      //   return;
      // }


      if (chatInfo) {
        let listaStatus = ['Pendente', 'Geral', 'Finalizado', 'Avaliando'];
        if (listaStatus.includes(chatInfo.statusRoom)) {
          if (chatInfo.numeroCliente === soNumeros(data.data.scope.message.chatId)) {
            if (data.data.to === user.id) {
              dispatch(setMessageWhatsapp(data.data.scope.message));
            }

            dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));
          }
        }
      }



      // verifica se é meu chat ou se usuario tem permissao root pra receber mensagens de qualquer cliente
      if (isMyChat || user.level === "root") {

        //verificando se é multi session
        if (isMultisession) {
          let listaNumerosClientesSubs = clienteParse?.numeros_subs || [];
          if (listaNumerosClientesSubs.includes(soNumeros(data.data.scope.message.to))) {

            if (
              chatInfo?.numeroCliente + '@c.us' !== data.data.scope.message.chatId &&
              chatInfo?.numeroCliente + '@lid' !== data.data.scope.message.chatId &&
              chatIdClean !== chatInfo?.numeroCliente
            ) {

              if (!data.data.scope.message.fromMe) {

                // Alerta ja foi resolvido por alertarNovaMensagem no topo do handler.

                let dataToUpdade = {
                  _id: data.data.scope.chat_id,
                  scope: {
                    novaMensagem: 'sim',
                    dataUltimaMensagem: new Date(),
                    lastUpdate: new Date(),
                    ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                    ...ctwaScopeFromMessage(data.data.scope.message),
                    "lastMessageWpp": {
                      "type": data.data.scope.message.type,
                      "message": checkMsgToInsert(data.data.scope.message),
                      "fromMe": data.data.scope.message.fromMe,
                      "timestamp": data.data.scope.message.t,
                      "ack": data.data.scope.message.ack,
                      "id": data.data.scope.message.id
                    }
                  }
                };
                dispatch(updateChatList(dataToUpdade));
                if (!dataChatByLista) {
                  dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                }
                setTimeout(() => {
                  dispatch(reorderChatsAtendimento())
                }, 200);

              }

            }

          }

          if (chatInfo && chatInfo?.numeroCliente) {

            if (data.data.scope.message.fromMe) {
              let cliente_id_chat = chatInfo?.cliente_id;
              let numero_chat = obterNumeroPorClienteId(cliente_id_chat, clienteParse?.numeros_subs_data || []);

              if (numero_chat === soNumeros(data.data.scope.message.from)) {
                // if (Config.numero + '@c.us' === message.response.from) {
                if (
                  chatInfo?.numeroCliente + '@c.us' === data.data.scope.message.chatId ||
                  chatInfo?.numeroCliente + '@lid' === data.data.scope.message.chatId ||
                  chatIdClean === chatInfo?.numeroCliente
                ) {

                  dispatch(setMessageWhatsapp(data.data.scope.message))
                  dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));
                  // Alerta ja foi resolvido por alertarNovaMensagem no topo do handler.
                  let dataToUpdade = {
                    _id: data.data.scope.chat_id,
                    scope: {
                      dataUltimaMensagem: new Date(),
                      lastUpdate: new Date(),
                      ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                      ...ctwaScopeFromMessage(data.data.scope.message),
                      "lastMessageWpp": {
                        "type": data.data.scope.message.type,
                        "message": checkMsgToInsert(data.data.scope.message),
                        "fromMe": data.data.scope.message.fromMe,
                        "timestamp": data.data.scope.message.t,
                        "ack": data.data.scope.message.ack,
                        "id": data.data.scope.message.id
                      }
                    }
                  };
                  dispatch(updateChatList(dataToUpdade));
                  setTimeout(() => {

                    dispatch(reorderChatsAtendimento())
                  }, 200);
                  if (!dataChatByLista) {
                    dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                  }
                  // dispatch(getCountsChats(user.clienteId, user.id, user.setorId));
                  if (["ptt", "image"].includes(data.data.scope.message.type)) {
                    setTimeout(() => {
                      downloadMediaAndSaveCache(data.data.scope.message, chatInfo, clienteParse);
                    }, 5000);
                  }


                }
              }

            } else {

              const cliente_id_chat = chatInfo?.cliente_id;
              const numero_chat = obterNumeroPorClienteId(cliente_id_chat, clienteParse?.numeros_subs_data || []);
              if (numero_chat === soNumeros(data.data.scope.message.to)) {
                if (
                  chatInfo?.numeroCliente + '@c.us' === data.data.scope.message.chatId ||
                  chatInfo?.numeroCliente + '@lid' === data.data.scope.message.chatId ||
                  chatIdClean === chatInfo?.numeroCliente
                ) {
                  let dataToUpdade = {
                    _id: data.data.scope.chat_id,
                    scope: {
                      novaMensagem: 'nao',
                      dataUltimaMensagem: new Date(),
                      lastUpdate: new Date(),
                      ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                      ...ctwaScopeFromMessage(data.data.scope.message),
                      "lastMessageWpp": {
                        "type": data.data.scope.message.type,
                        "message": checkMsgToInsert(data.data.scope.message),
                        "fromMe": data.data.scope.message.fromMe,
                        "timestamp": data.data.scope.message.t,
                        "ack": data.data.scope.message.ack,
                        "id": data.data.scope.message.id
                      }
                    }
                  };

                  dispatch(updateChatList(dataToUpdade));
                  setTimeout(() => {
                    dispatch(reorderChatsAtendimento())
                  }, 200);
                  if (!dataChatByLista) {
                    dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                  }
                  dispatch(setMessageWhatsapp(data.data.scope.message));

                  if (data.data.scope.message.platform === "whatsapp_business") {
                    let timestampToDate = new Date((data.data.scope.message.t * 1000));
                    if (!data.data.scope.message.fromMe) {
                      dispatch(updateChatInfoField('lastDateMsgClient', timestampToDate));
                      if (data.data.scope.message.referral) {
                        dispatch(updateChatInfoField('ctwaReferralAt', timestampToDate));
                        dispatch(updateChatInfoField('ctwaWindowClosedAt', null));
                      }
                    }
                  }


                  dispatch(addNewMessageCliente({
                    ...data.data.scope.message,
                    chatId: data.data.scope.chat_id
                  }))
                  dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));

                }
              }
            }
          }

          // cliente nao multi session
        } else {
          // verificando se o numero do cliente painel é o mesmo do numero que chegou a mensagem
          console.log('DEBUG 1')
          // verificando se o chat nao existe e se é meu chat
          if (!chatInfo) {
            // Alerta ja foi resolvido por alertarNovaMensagem no topo do handler.
            let dataToUpdade = {
              _id: data.data.scope.chat_id,
              scope: {
                dataUltimaMensagem: new Date(),
                lastUpdate: new Date(),
                ...(!data.data.scope.message.fromMe ? { novaMensagem: 'sim', lastDateMsgClient: new Date() } : {}),
                ...ctwaScopeFromMessage(data.data.scope.message),
                "lastMessageWpp": {
                  "type": data.data.scope.message.type,
                  "message": checkMsgToInsert(data.data.scope.message),
                  "fromMe": data.data.scope.message.fromMe,
                  "timestamp": data.data.scope.message.t,
                  "ack": data.data.scope.message.ack,
                  "id": data.data.scope.message.id
                }
              }
            };
            dispatch(updateChatList(dataToUpdade));
            if (!dataChatByLista) {
              dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
            }
            setTimeout(() => {
              dispatch(reorderChatsAtendimento())
            }, 500);
            return;
          }

          // QUANDO EXISTE UM CHAT SELECIONADO
          if (chatInfo) {
            // QUANDO A MSG É DO CHAT SELECIONADO
            if (
              chatInfo?.numeroCliente + '@c.us' === data.data.scope.message.chatId ||
              chatInfo?.numeroCliente + '@lid' === data.data.scope.message.chatId ||
              chatIdClean === chatInfo?.numeroCliente
            ) {

              dispatch(setMessageWhatsapp(data.data.scope.message));
              dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));

              // Adicionar nova mensagem do cliente ao estado para mostrar botão de novas mensagens
              if (!data.data.scope.message.fromMe) {
                console.log('📨 Adicionando nova mensagem do cliente (chat selecionado):', {
                  message: data.data.scope.message,
                  chatId: data.data.scope.chat_id,
                  platform: data.data.scope.message.platform
                });
                dispatch(addNewMessageCliente({
                  ...data.data.scope.message,
                  chatId: data.data.scope.chat_id
                }));
              }

              if (data.data.scope.message.platform === "whatsapp_business") {
                let timestampToDate = new Date((data.data.scope.message.t * 1000));
                if (!data.data.scope.message.fromMe) {
                  dispatch(updateChatInfoField('lastDateMsgClient', timestampToDate));
                  if (data.data.scope.message.referral) {
                    dispatch(updateChatInfoField('ctwaReferralAt', timestampToDate));
                    dispatch(updateChatInfoField('ctwaWindowClosedAt', null));
                  }
                }
              }

              let dataToUpdade = {
                _id: data.data.scope.chat_id,
                scope: {
                  novaMensagem: 'nao',
                  dataUltimaMensagem: new Date(),
                  ...(!data.data.scope.message.fromMe ? { lastDateMsgClient: new Date() } : {}),
                  ...ctwaScopeFromMessage(data.data.scope.message),
                  lastUpdate: new Date(),
                  "lastMessageWpp": {
                    "type": data.data.scope.message.type,
                    "message": checkMsgToInsert(data.data.scope.message),
                    "fromMe": data.data.scope.message.fromMe,
                    "timestamp": data.data.scope.message.t,
                    "ack": data.data.scope.message.ack,
                    "id": data.data.scope.message.id
                  }
                }
              };

              dispatch(updateChatList(dataToUpdade));
              if (!dataChatByLista) {
                dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
              }

              dispatch(updateChatList(dataToUpdade));
              setTimeout(() => {
                dispatch(reorderChatsAtendimento())
              }, 500);


              /// verificar função abaixo

              //   if (
              //     data.data.scope.message.fromMe && 
              //     clienteParse.numero + '@c.us' === data.data.scope.message.from
              //   ) {
              //         console.log('aqui 04')
              //         dispatch(setMessageWhatsapp(data.data.scope.message));
              //         let dataToUpdade = {
              //           _id: data.data.scope.chat_id,
              //           scope: {
              //             novaMensagem: 'sim',
              //             dataUltimaMensagem: new Date(),
              //             lastUpdate: new Date(),
              //             "lastMessageWpp": {
              //               "type": data.data.scope.message.type,
              //               "message": checkMsgToInsert(data.data.scope.message),
              //               "fromMe": data.data.scope.message.fromMe,
              //               "timestamp": data.data.scope.message.t,
              //               "ack": data.data.scope.message.ack,
              //               "id": data.data.scope.message.id
              //             }
              //           }
              //         };
              //         dispatch(updateChatList(dataToUpdade));
              //         setTimeout(() => {
              //           dispatch(reorderChatsAtendimento())
              //         }, 200);
              //         dispatch(removeMensagensEnviarByChatId(data.data.scope.chat_id || chatInfo?._id));
              //         dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));

              // } 
              console.log('debug 59')
              return;
              // QUANDO A MSG NAO É DO CHAT SELECIONADO
            } else {
              console.log('chat selecionado, mas nao é do cliente que vei msg')
              if (chatInfo?.statusRoom === "Atendendo") {
                console.log('chat está em status Atendendo')

                // Alerta ja foi resolvido por alertarNovaMensagem no topo do handler.

                let dataToUpdade = {
                  _id: data.data.scope.chat_id,
                  scope: {
                    dataUltimaMensagem: new Date(),
                    lastUpdate: new Date(),
                    ...(!data.data.scope.message.fromMe ? { novaMensagem: 'sim', lastDateMsgClient: new Date() } : {}),
                    ...ctwaScopeFromMessage(data.data.scope.message),
                    "lastMessageWpp": {
                      "type": data.data.scope.message.type,
                      "message": checkMsgToInsert(data.data.scope.message),
                      "fromMe": data.data.scope.message.fromMe,
                      "timestamp": data.data.scope.message.t,
                      "ack": data.data.scope.message.ack,
                      "id": data.data.scope.message.id
                    }
                  }
                };
                dispatch(updateChatList(dataToUpdade));
                if (!dataChatByLista) {
                  dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 100, false));
                }
                setTimeout(() => {

                  dispatch(reorderChatsAtendimento())
                }, 500);
                return;
              }
            }
            //fim do buscar atendimento
          }

        }

        // Mesmo escopo do loop original: dentro de `isMyChat || root` e sem
        // Atendendo (o loop tinha um bloco vazio + a linha comentada de
        // proposito). O emit e endereçado a organizacao inteira, entao tirar o
        // refetch daqui faria todo agente refetchar a cada mensagem.
        // Quem atualiza a fila para os demais e `socket-device-refresh-list-chats`.
        agendarRefetchListas(data?.data?.scope?.lista_atualizar, { ignorar: ['Atendendo'] });
      }
    });


    on('msgInstagramDeleted', async data => {
      if (!isReadyV2()) return;
      const chatInfo = store.getState().chat.chatInfo;
      const instagramUserId = data.data.scope.instagramUserId;

      if (chatInfo?.instagramUser?.id === instagramUserId) {
        dispatch(getMessagesMeta(chatInfo?.sessao, instagramUserId));
      }
    });

    // Mensagens de Instagram Direct (pipeline metaPage do lais-webhook).
    // O shape emitido e IG-nativo (transformMessageMetaPage): scope.message tem
    // instagramUserId/userId + message.{isMe,isFile,message.{mid,text}} — NAO tem
    // telefone/chatId/to. O handler antigo reaproveitava a logica do WhatsApp
    // (numeros_subs, soNumeros(chatId)) e estourava TypeError na entrada, entao
    // nenhuma mensagem de IG chegava em tempo real. Espelha o newMessageMessenger.
    on('newMessageInstagram', async data => {
      if (!isReadyV2()) return;
      try {
        const scope = data?.data?.scope;
        const message = scope?.message;
        if (!message) return;

        const instagramUserId = message.instagramUserId || message.userId;
        const isMe = !!message.message?.isMe;
        const mappedRaw = mapMetaMessageToBubble(message);
        const mapped = enrichQuotedMetaMessages(
          [mappedRaw],
          store.getState().chat.mensagens
        )[0];

        const chatInfo = store.getState().chat.chatInfo;
        const chatAberto = chatInfo?.canal === 'instagram' && chatInfo?.instagramUser?.id === instagramUserId;

        // Render ao vivo no chat aberto (echo do que enviamos ou mensagem recebida).
        // No echo, remove o balao otimista correspondente de mensagensEnviar por body.
        if (chatAberto) {
          reconciliarMensagemOtimista(dispatch, mapped, scope?.chat_id || chatInfo?._id);
          dispatch(setMessageWhatsapp(mapped));
          if (!mapped.fromMe) {
            dispatch(addNewMessageCliente({ ...mapped, chatId: scope.chat_id }));
          }
        }

        // Preview/ordenacao da conversa na lista, sem refetch (chat_id vem no scope).
        if (scope.chat_id) {
          dispatch(updateChatList({
            _id: scope.chat_id,
            scope: {
              ...(!isMe ? { novaMensagem: chatAberto ? 'nao' : 'sim', lastDateMsgClient: new Date() } : {}),
              dataUltimaMensagem: new Date(),
              lastUpdate: new Date(),
              lastMessageWpp: {
                type: mapped.type,
                message: checkMsgToInsert(mapped),
                fromMe: mapped.fromMe,
                timestamp: mapped.t,
                ack: mapped.ack,
                id: mapped.id
              }
            }
          }));
          setTimeout(() => dispatch(reorderChatsAtendimento()), 200);
        }

        // Som + notificacao desktop: so quando a conversa e MINHA, ou seja quando
        // o backend mandou usuario_id (status Atendendo, com direciona_usuarios).
        // Pendente/Geral/Avaliando/Finalizado saem como emit generico, sem
        // usuario_id — aceitar esses aqui alertava toda a organizacao a cada
        // mensagem de fila. Mesma regra do WhatsApp (isEventoRelevante) e do
        // Messenger (souDonoMessenger); o IG era o unico fora do padrao.
        //
        // A supressao por "conversa aberta" passa pela politica de foco — com a
        // aba em segundo plano o alerta sai mesmo com a conversa aberta na tela.
        const deveAlertar = shouldNotifyMessage({
          chatIdEvento: instagramUserId,
          chatAbertoId: chatAberto ? instagramUserId : null,
        });
        if (!isMe && isEventoRelevante({ envelope: data?.data, scope, user }) && deveAlertar) {
          playAlert("message");

          const listaChats = store.getState().chat.chatsAtendimento || [];
          const chatDaLista = listaChats.find((c) => c?.instagramUser?.id === instagramUserId);
          const nome = chatDaLista?.nomeCliente
            || chatDaLista?.instagramUser?.profile?.username
            || 'Instagram';
          createNotify(nome, rotuloMensagem(mapped), {
            tag: scope.chat_id ? `chat:${scope.chat_id}` : undefined,
            chatId: scope.chat_id,
          });
        }

        // Refresh das listas indicadas pelo scope (fora do gate de usuario_id — os
        // emits genericos de Geral/Pendente/Finalizado nao carregam usuario_id).
        agendarRefetchListas(scope.lista_atualizar);
      } catch (err) {
        console.error('[instagram] handler newMessageInstagram falhou', err, data);
      }
    });

    // Updates de mensagem ja existente no Instagram (delete/edit/reaction via metaPage).
    on('updateMessageInstagram', data => {
      if (!isReadyV2()) return;
      try {
        const scope = data?.data?.scope;
        if (!scope?.mid || !scope?.type) return;
        if (scope.usuario_id && scope.usuario_id !== user.id) return;

        const chatInfo = store.getState().chat.chatInfo;
        const chatAberto = chatInfo?._id && scope.chat_id && String(chatInfo._id) === String(scope.chat_id);

        if (scope.type === 'deleted') {
          if (chatAberto) {
            dispatch(patchMessageById({
              id: scope.mid,
              patch: { isDeleted: true }
            }));
          }
          // Preview na lista: se a ultima mensagem era a apagada, mostra "Mensagem apagada".
          if (scope.chat_id) {
            const listas = [
              store.getState().chat.chatsAtendimento,
              store.getState().chat.chatsPendente,
              store.getState().chat.chatsGeral,
              store.getState().chat.chatsFinalizado
            ];
            const chatNaLista = listas.flat().find((c) => c && String(c._id) === String(scope.chat_id));
            if (chatNaLista?.lastMessageWpp?.id === scope.mid) {
              dispatch(updateChatList({
                _id: scope.chat_id,
                scope: {
                  lastMessageWpp: {
                    ...chatNaLista.lastMessageWpp,
                    type: 'chat',
                    message: 'Mensagem apagada'
                  }
                }
              }));
            }
          }
        }
      } catch (err) {
        console.error('[instagram] handler updateMessageInstagram falhou', err, data);
      }
    });


    // recebendo mensagens websocket do Messenger (pipeline metaPage)
    on('newMessageMessenger', async data => {
      if (!data) return;
      // Mesmo gate dos demais canais v2 (consistencia com newMessage/newMessageInstagram)
      if (!isReadyV2()) return;

      const scope = data?.data?.scope;
      const message = scope?.message;
      if (!message) return;

      // So reage se o evento for direcionado a este usuario (igual ao IG)
      if (scope?.usuario_id && scope.usuario_id !== user.id) return;

      const messengerUserId = message.messengerUserId || message.userId;
      const chatInfo = store.getState().chat.chatInfo;
      const chatAbertoMessenger = chatInfo?.canal === 'messenger' && chatInfo?.messengerUser?.id === messengerUserId;

      const mappedMessenger = enrichQuotedMetaMessages(
        [mapMetaMessageToBubble(message)],
        store.getState().chat.mensagens
      )[0];

      // O Messenger era o unico canal que tocava o som SO quando a conversa ja
      // estava aberta — exatamente o inverso dos outros — e nunca mostrava
      // notificacao de desktop. Agora usa a mesma politica dos demais canais.
      //
      // O guard de cima aceita `usuario_id` ausente para nao travar a
      // atualizacao da lista; o ALERTA exige ser o dono, senao uma conversa sem
      // atribuicao notificaria todos os agentes da organizacao.
      const souDonoMessenger = mesmoId(scope?.usuario_id, user.id);
      if (souDonoMessenger && !message.message?.isMe && shouldNotifyMessage({
        chatIdEvento: messengerUserId,
        chatAbertoId: chatAbertoMessenger ? messengerUserId : null,
      })) {
        playAlert('message');
        notify({
          title: chatInfo?.nomeCliente || mappedMessenger?.sender?.formattedName || 'Nova mensagem',
          body: rotuloMensagem(mappedMessenger),
          tag: scope?.chat_id ? `chat:${scope.chat_id}` : undefined,
          chatId: scope?.chat_id,
        });
      }

      // Atualiza o chat aberto se for o mesmo usuario
      if (chatInfo && chatInfo.messengerUser?.id === messengerUserId) {
        dispatch(setPushMensagemMeta(message));
        // Renderiza ao vivo no chat aberto (slice mensagens, ja no shape do balao)
        // e remove o balao otimista do envio, como no Instagram.
        reconciliarMensagemOtimista(dispatch, mappedMessenger, scope?.chat_id || chatInfo?._id);
        dispatch(setMessageWhatsapp(mappedMessenger));
      }

      // Preview/ordenacao da conversa na lista, sem refetch (igual ao Instagram).
      if (scope?.chat_id) {
        dispatch(updateChatList({
          _id: scope.chat_id,
          scope: {
            ...(!mappedMessenger.fromMe ? { novaMensagem: chatAbertoMessenger ? 'nao' : 'sim', lastDateMsgClient: new Date() } : {}),
            dataUltimaMensagem: new Date(),
            lastUpdate: new Date(),
            lastMessageWpp: {
              type: mappedMessenger.type,
              message: checkMsgToInsert(mappedMessenger),
              fromMe: mappedMessenger.fromMe,
              timestamp: mappedMessenger.t,
              ack: mappedMessenger.ack,
              id: mappedMessenger.id
            }
          }
        }));
        setTimeout(() => dispatch(reorderChatsAtendimento()), 200);
      }

      // Atualiza as listas indicadas pelo scope
      const lista = scope?.lista_atualizar || [];
      for (const item of lista) {
        if (item === "Atendendo") dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, false));
        if (item === "Geral") dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, false));
        if (item === "Pendente") dispatch(getChatsPendente(user.clienteId, user.id, user.setorId, 10, false));
        if (item === "Finalizado") dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 10, false));
      }
    });

    // Updates de mensagem ja existente no Messenger (delete/edit/reaction via metaPage).
    on('updateMessageMessenger', data => {
      try {
        const scope = data?.data?.scope;
        if (!scope?.mid || !scope?.type) return;
        if (scope.usuario_id && scope.usuario_id !== user.id) return;

        const chatInfo = store.getState().chat.chatInfo;
        const chatAberto = chatInfo?._id && scope.chat_id && String(chatInfo._id) === String(scope.chat_id);

        if (scope.type === 'deleted') {
          if (chatAberto) {
            dispatch(patchMessageById({
              id: scope.mid,
              patch: { isDeleted: true }
            }));
          }
          if (scope.chat_id) {
            const listas = [
              store.getState().chat.chatsAtendimento,
              store.getState().chat.chatsPendente,
              store.getState().chat.chatsGeral,
              store.getState().chat.chatsFinalizado
            ];
            const chatNaLista = listas.flat().find((c) => c && String(c._id) === String(scope.chat_id));
            if (chatNaLista?.lastMessageWpp?.id === scope.mid) {
              dispatch(updateChatList({
                _id: scope.chat_id,
                scope: {
                  lastMessageWpp: {
                    ...chatNaLista.lastMessageWpp,
                    type: 'chat',
                    message: 'Mensagem apagada'
                  }
                }
              }));
            }
          }
        }
      } catch (err) {
        console.error('[messenger] handler updateMessageMessenger falhou', err, data);
      }
    });

    // Comentarios de posts Facebook/Instagram (pipeline metaPage do lais-webhook).
    // O webhook so emite quando o comentario NAO e nosso (isMe false), entao todo
    // evento aqui e algo que o atendente precisa responder.
    let timerRefreshComentarios = null;

    on('newSocialComment', data => {
      console.debug('[comentarios] newSocialComment recebido', data);
      const scope = data?.data?.scope;
      if (!scope) return;
      if (data.data.whoTo === "clienteId" && data.data.to !== user.clienteId) return;

      // Estado ANTES do dispatch: e ele que diz se o atendente estava olhando o post.
      const { activeChatTab, selectedPost } = store.getState().socialComments;
      const naAbaComentarios = activeChatTab === 'comentarios';
      const postAberto = naAbaComentarios && selectedPost?.post_id === scope.post_id;

      dispatch(receiveSocketComment(scope));

      // Post novo entra na lista como stub (sem legenda/thumb). Recarrega a listagem
      // para hidratar — so com a aba aberta, ja que o refetch dispara Graph API.
      if (naAbaComentarios) {
        clearTimeout(timerRefreshComentarios);
        timerRefreshComentarios = setTimeout(() => dispatch(getSocialPosts(user.clienteId)), 3000);
      }

      // Fora do post aberto o atendente nao ve o comentario chegar: som + desktop.
      if (!postAberto) {
        playAlert("message");

        const autor = scope.comment?.from?.username || scope.comment?.from?.name || 'Alguém';
        const rede = scope.platform === 'instagram' ? 'Instagram' : 'Facebook';
        notifyMeComentario(`Novo comentário no ${rede}`, `${autor}: ${scope.comment?.text || ''}`);
      }
    });

    on('updateSocialComment', data => {
      const scope = data?.data?.scope;
      if (!scope) return;
      if (data.data.whoTo === "clienteId" && data.data.to !== user.clienteId) return;
      dispatch(patchComment(scope));
    });


  on(`${user.clienteId}-meta-message`, data => {
    const currentChat = store.getState().chat.chatInfo;
    if (!currentChat) return null;

    if (data.cliente_id === user.clienteId) {
      if (data.id_usuario === currentChat.instagram_user_id) {
        dispatch(setMetaMessages(data.message))
      }

    }
  });


  on(`atualizar-dados-cliente`, async () => {
    const responseCliente = await getActionClienteByClienteId(user.clienteId);
    const response_clientes_canais = await actionListaClientesCanais(user.clienteId);

    let listaNumerosSubs = response_clientes_canais.data.numeros_subs;
    const numeros_subs_reduce = listaNumerosSubs.map((item) => item.nome)

    const newClienteObj = {
      ...responseCliente.data.cliente,
      clientes_canais: responseCliente.data.cliente.multiSession === 1 ? response_clientes_canais.data.data : [],
      numeros_subs: responseCliente.data.cliente.multiSession === 1 ? numeros_subs_reduce : [],
      numeros_subs_data: responseCliente.data.cliente.multiSession === 1 ? listaNumerosSubs : []
    }

    localStorage.setItem('cliente_data', JSON.stringify(newClienteObj));

    window.location.href = "/";
  });

  on(`atualizar-front`, () => {
    window.location.href = "/";
  });

  on(`force-logout`, (data) => {

    function clear() {
      // Limpar o cache de armazenamento local
      localStorage.clear();

      // Limpar o cache de sessão
      sessionStorage.clear();

      // Limpar todos os cookies
      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }

      // Recarregar a página para aplicar as alterações
      window.location.reload();
    }


    if (data.data.whoTo === "clienteId" && data.data.to === user.clienteId) {
      clear()
    } else if (data.data.whoTo === "usuarioId" && data.data.to === user.id) {
      clear()
    }

  });


  const verificaIsDefcon1 = () => {
    on(`_defcon1`, data => {
      if (data) {
        dispatch(setDefcon1(Boolean(data.status)))
      }
    });

  }
  verificaIsDefcon1()


  on(`_defcon`, data => {
    if (data.tipo === "defcon1") {
      dispatch(setDefcon1(Boolean(data.status)))
    }
    if (data.tipo === "update_available") {
      dispatch(setUpdateAvailable(Boolean(data.status)))
    }
  });

  on(`state_whatsapp`, data => {
    console.log('data', data?.data?.scope);
    dispatch(setStateWhatsapp(data?.data?.scope));
  });

  io.on('disconnect', (reason) => {
    // O motivo distingue queda de rede de desconexao pelo servidor; sem ele nao
    // da para saber por que o painel parou de receber eventos.
    console.warn('[socket] desconectado:', reason);
  });


  on('private message', () => {
    console.log('DESCONECTADO')
  });

  on('new-analysis-chat', (data) => {
    const currentChat = store.getState().chat.chatInfo;
    if (data?.data?.scope?.analyze?.chat_id === currentChat?._id) {
      dispatch(setChatsAnalysis(data?.data?.scope?.analyze))

    }
  })


  // Shims sobre notify(): mantem os call sites existentes e herda tag, clique
  // para abrir a conversa e auto-close. Nao pedem mais permissao aqui — pedir
  // fora de um gesto do usuario e recusado por Firefox/Safari e ainda descarta a
  // notificacao que disparou o pedido.
  const notifyMe2 = () => {
    notify({
      title: 'CHATS PENDENTES',
      body: 'Você tem chat(s) no seu painel',
      tag: 'fila',
      url: PATH_CHAT.chat.root,
    });
  }

  const createNotify = (title, message, extras = {}) => {
    notify({ title, body: message, ...extras });
  }




};

export default initIO;
